/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { IEditor } from "../../IEditor";
import { registerCommands } from "./Commands";
import { ViewEditorEditMain } from "./ViewEditorEdit/components/ViewEditorEditMain";
import { registerKeyBindings } from "./KeyBindings";
import { ViewEditorView } from "./ViewEditorEdit/ViewEditorView";
import { ViewEditorCreate } from "./ViewEditorCreate/ViewEditorCreate";
import { ViewEditorCreateMain } from "./ViewEditorCreate/components/ViewEditorCreateMain";
import { registerMenus } from "./Menus";
import { VIEW_EDITOR_VIEWS } from "./ViewType";
import { CMD } from "../../commands/CMD";

export function ViewEditorModule(dc: IEditor): void {
	dc.get("logger").debug("UI Editor module enabled.");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView(VIEW_EDITOR_VIEWS.EDIT, ViewEditorView, ViewEditorEditMain);
	viewSvc.registerView(VIEW_EDITOR_VIEWS.CREATE, ViewEditorCreate, ViewEditorCreateMain);

	resourceSvc.registerResourceView(RESOURCE_TYPES.VIEW, VIEW_EDITOR_VIEWS.EDIT);
	resourceSvc.registerResourceCreateCommand(RESOURCE_TYPES.VIEW, CMD.VIEW_EDITOR.CREATE.OPEN);

	registerCommands(dc);
	registerKeyBindings(dc);
	registerMenus(dc);
}
